import React from 'react'

export default props => (
  <svg viewBox="0 0 48 48" style={{ background: 'white' }} {...props}>
    <path
      fill="#bcbbbb"
      d="M33.76 37.52v-9.28h3.08V40.6H9.04V28.24h3.08v9.28z"
    />
    <path
      fill="#f48023"
      d="M15.52 27.36l15.12 3.16.64-3.04-15.12-3.16-.64 3.04zm2-7.2l14 6.52 1.28-2.8-14-6.56-1.28 2.84zm3.88-6.88l11.88 9.88 1.96-2.36-11.88-9.88-1.96 2.36zm7.68-7.32L26.6 7.8l9.2 12.4 2.48-1.84-9.2-12.4zM15.2 34.4h15.44v-3.08H15.2v3.08z"
    />
  </svg>
)
